import React from 'react';
import { createComponent } from '@lit/react';
import { SDSIcon } from '../sds-icon/sds-icon';

export const SDSIconWrapper = createComponent({
	tagName: 'sds-icon',
	elementClass: SDSIcon,
	react: React,
	events: {},
});
